export default __webpack_public_path__ + "static/media/domains-en.67ccd3dd.svg";